import React, {Component} from 'react';
import {
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    FormText, FormFeedback, CustomInput
} from 'reactstrap';

import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import ColorInput from '../../../shared/components/ColorInput';
import DateInput from "react-datepicker";
import moment from "moment";
import {loadProgramsForAgency} from "../../../shared/redux/entities/actions";

class EditProgram extends Component {
    constructor(props) {
        super(props);
        this.endedTextRef = React.createRef();

        this.state = {
            colorValid: true,
            isUpdating: false,
            isActivating: false,
            giftCard: null,
            scanCTA: false,
            error: null,
            validateForm: false
        }
    }

    componentWillMount() {
        const {program} = this.props
        if (program) {
            this.setState({...program,
                startDate: program.startDate ? moment(moment.utc(program.startDate).format('LL')).startOf('day') : moment(),
                endDate: program.endDate ? moment(moment.utc(program.endDate).format('LL')).startOf('day') : moment(),
                giftCard: this.props.giftCards.filter((c) => c.id === program.giftCardId).shift(),
                displayDays: program.displayDays || 7,
                validateForm: true});
        } else {
            this.setState({startDate: moment(),
                endDate:  moment(this.state.startDate).add(7, "day"),
                displayDays: 7,
                feedText: 'Exclusive Earnings toward a $$ retailer gift card',
                cardText: 'You have a gift card waiting for you',
                scanText: 'This program has ended. Accumulated points will be transferred to your Downtime Dollars balance on or after end date ',
                endedText: 'Upload receipts for any of these products and earn more!',
                colorValid: false
            });
        }
    }

    handleColorChange(color) {
        const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

        if (isValid) {
            this.setState({
                backgroundColor: color,
                colorValid: isValid
            })
        } else {
            this.setState({colorValid: isValid})
        }
    }

    handleLogoChange(logos) {
        this.setState({
            logoId: logos.id,
            logoThumbnailURL: logos.thumbnail,
            logoFileName: logos.fileName,
            logoUrl: logos.large
        });
    }

    handleNameChange(name) {
        this.setState({
            name: name
        });
    }

    getCardTitle(card) {
        return card ? `${card.title}($${card.minValue}-$${card.maxValue})` : ''
    }

    handleGiftCardChange(giftCardId){
        const giftCard = this.props.giftCards.filter((c) => c.id === giftCardId).shift()
        this.setState({giftCardId: giftCardId, giftCard: giftCard, cardAmount: this.state.cardAmount || giftCard.minValue});
    }

    handleCardAmountChange(cardAmount){
        this.setState({cardAmount: cardAmount});
    }

    isCardAmountValid(){
        const {giftCard, cardAmount} = this.state
        return giftCard === null || this.state.cardAmount && giftCard.minValue <= cardAmount && giftCard.maxValue >= cardAmount
    }

    handleBudgetChange(budget) {
        this.setState({ budget: budget });
    }

    isValidProgram() {
        const {name, cardAmount, giftCardId, logoUrl, feedText, cardText, scanText, endedText, startDate, endDate, displayDays, budget, scanCTA, colorValid} = this.state
        return name && this.isCardAmountValid() && giftCardId && logoUrl && feedText && cardText && endedText && scanText && colorValid && startDate < endDate && displayDays > 0 && budget && Number(budget) >= Number(cardAmount)
    }

    handleSubmit(data) {
        console.debug("handleSubmit")
        if (!this.isValidProgram()) {
            this.setState({validateForm: true})
            return
        }
        const program = this.props.program || {}
        const {isCreate, loadProgramsForAgency, agencyId} = this.props
        const {name, cardAmount, giftCardId, logoUrl, feedText, cardText, scanText, endedText, backgroundColor, startDate, endDate, displayDays, budget, scanCTA} = this.state
        const requestData = {
            ...(name !== program.name && {name: name}),
            ...(cardAmount !== program.cardAmount && {cardAmount: cardAmount}),
            ...(giftCardId !== program.giftCardId && {giftCardId: giftCardId}),
            ...(logoUrl !== program.logoUrl && {logoUrl: logoUrl}),
            ...(feedText !== program.feedText && {feedText: feedText}),
            ...(cardText !== program.cardText && {cardText: cardText}),
            ...(scanText !== program.scanText && {scanText: scanText}),
            ...(endedText !== program.endedText && {endedText: endedText}),
            ...(backgroundColor !== program.backgroundColor && {backgroundColor: backgroundColor}),
            ...((!program.startDate || startDate.format('LL') !== moment.utc(program.startDate).format('LL')) && {startDate: this.state.startDate.add(this.state.startDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            ...((!program.endDate || endDate.format('LL') !== moment.utc(program.endDate).format('LL')) && {endDate: this.state.endDate.add(this.state.endDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            // ...((!program.displayDate || displayDate.format('LL') !== moment.utc(program.displayDate).format('LL')) && {displayDate: this.state.displayDate.add(this.state.displayDate.utcOffset(), 'm').startOf("day").utc().valueOf()}),
            ...(displayDays !== program.displayDays && {displayDays: displayDays}),
            ...(budget !== program.budget && {budget: budget}),
            ...(scanCTA !== program.scanCTA && {scanCTA: scanCTA}),
            ...(isCreate && {status: 'draft'})
        }
        console.debug(requestData)


            this.setState({isUpdating: true, error: null});

            if (this.props.isCreate) {
                this.props.createProgram({
                    agencyId: this.props.agencyId,
                    ...requestData
                })
                    .then((res)=>res.instance.id)
                    .then((id) => { loadProgramsForAgency(agencyId); return id;})
                    .then((id) => {
                        this.props.history.replace(`${this.getBackLink()}/${id}`);
                        window.location.reload();
                    })
                    .then((res) => this.handleSuccess())
                    .then(() => this.componentWillMount())
                    .catch((err) => this.handleFailure(err));
            } else {
                this.props.updateProgram(this.props.program.id, requestData)
                    .then((res) => this.handleSuccess())
                    .catch((err) => this.handleFailure(err));
            }
    }

    onActivateClick(){
        this.setState({isActivating: true, error: null});
        this.props.updateProgram(this.props.program.id, {status: 'active'})
            .then((res) => this.props.history.push(this.getBackLink(), {needUpdatePrograms: true}))
            // .then((res) => this.setState({status: 'active', isActivating: false}))
            .catch((err) => {
                this.handleFailure(JSON.parse(err.message.replace(/'/g, '"')))
            });
    }

    handleSuccess() {
        this.setState({isUpdating: false, isActivating: false});
    }

    handleFailure(err) {
        this.setState({error: err, isUpdating: false, isActivating: false});
    }

    getSubmitText() {
        if (this.state.isUpdating && this.props.isCreate) {
            return 'Creating';
        } else if (this.state.isUpdating) {
            return 'Updating';
        } else if (this.props.isCreate) {
            return 'Create';
        } else {
            return 'Update';
        }
    }

    getBackLink() {
        return this.props.match.url.substring(0, this.props.match.url.lastIndexOf('/'));
    }

    // isProgramValid(){
    //     const {name, cardAmount, giftCardId, logoUrl, feedText, cardText, scanText, endedText, startDate, endDate, displayDate, budget, scanCTA, colorValid} = this.state
    //     return name &&
    //         giftCardId &&
    //         this.isCardAmountValid() &&
    //         logoUrl &&
    //         colorValid &&
    //         startDate && startDate >= moment().startOf("day") &&
    //         endDate && endDate >= startDate &&
    //         displayDate && displayDate >= endDate &&
    //         feedText && cardText && endedText && (!scanCTA || scanText) &&
    //         budget && Number(budget) >= Number(cardAmount)
    // }

    render() {
        const {
            isCreate,
            program,
            giftCards
        } = this.props;
        const {name, cardAmount, giftCardId, logoUrl, feedText, cardText, scanText, endedText, backgroundColor, startDate, endDate, displayDays, budget, scanCTA, status} = this.state

        const {
            isUpdating,
            isActivating,
            colorValid,
            giftCard,
            validateForm,
            error
        } = this.state;

        if (!isCreate && !program) {
            return <div>Program failed to load</div>
        }

        return (
            <Container style={{marginBottom:'1rem'}}>
                <Row>
                    <Col xs='10'>
                        <h3>{isCreate ? 'Create Program' : `Edit ${program.name}`}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <FormGroup row>
                                <Label for="name" sm={4}>Program Name</Label>
                                <Col sm={8}>
                                    <Input name="name"
                                           id="name"
                                           defaultValue={name}
                                           onChange={(e) => this.handleNameChange(e.target.value)}
                                           invalid={(!name || name.length === 0) && validateForm}
                                           placeholder="free form, up to 50 characters"/>
                                    {(!name || name.length === 0) && <FormFeedback>Program Name is required</FormFeedback> }
                                    <FormText>Program name will be referenced in reporting</FormText>
                                </Col>
                            </FormGroup>
                            {/*<FormGroup row>*/}
                            {/*    <Label for="selectBrands" sm={4}>Choose Brands</Label>*/}
                            {/*    <Col sm={8}>*/}
                            {/*        <Input type="select" name="selectMulti" id="selectBrands" multiple defaultValue={brandIds}>*/}
                            {/*            {brands.map((c) => (*/}
                            {/*                <option key={c.id} value={c.id}>*/}
                            {/*                    {c.name}*/}
                            {/*                </option>*/}
                            {/*            ))}*/}
                            {/*        </Input>*/}
                            {/*        <Row><Col sm={12}><FormText>Select which brand(s) to include in the program</FormText></Col></Row>*/}
                            {/*    </Col>*/}
                            {/*</FormGroup>*/}
                            <FormGroup row>
                                <Label for="programGiftCardid" sm={4}>Choose a Gift Card</Label>
                                <Col sm={8}>
                                    <Input type='select'
                                           name='programGiftCardid'
                                           defaultValue={giftCardId}
                                           invalid={!giftCardId && validateForm}
                                           onChange={(e) => this.handleGiftCardChange(e.target.value)}>
                                        <option key='' value=''>Not Selected</option>
                                        {giftCards.map((c) => (
                                            <option key={c.id} value={c.id}>
                                                {this.getCardTitle(c)}
                                            </option>
                                        ))}
                                    </Input>
                                    <FormFeedback>Gift Card is required</FormFeedback>
                                    <FormText>Select the gift card users will receive upon program completion</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="cardAmount" sm={4}>Denomination</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="cardAmount"
                                           id="cardAmount"
                                           defaultValue={cardAmount}
                                           onChange={(e) => this.handleCardAmountChange(e.target.value)}
                                           invalid={!this.isCardAmountValid() && validateForm}
                                           placeholder="value in range of selected gift card"/>
                                    <FormFeedback>{cardAmount ? `Denomination should be in range of ${this.getCardTitle(this.state.giftCard)}` : "Denomination shouldn't be empty"}</FormFeedback>
                                    <FormText>Pick gift card denomination</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="logo" sm={4}>Retailer logo</Label>
                                <Col sm={8}>
                                    <DroppableFileInput
                                        text='Retailer logo'
                                        fileType='image'
                                        onChange={(logo) => this.handleLogoChange(logo)}
                                        cropperAspectRatio={2 / 1}
                                        existingFileName={logoUrl ? logoUrl.split('/').pop(): ''}
                                        existingFileURL={logoUrl}
                                        warning={ logoUrl || !validateForm ? '' : 'Logo is required'}
                                    />
                                    <Row><Col sm={12}><FormText>What logo do you want to show in app?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup color={colorValid ? '' : 'danger'} row>
                                <Label for='backgroundColor' sm={4}>Choose a Color</Label>
                                <Col sm={8}>
                                    <ColorInput
                                        id='backgroundColor'
                                        name='backgroundColor'
                                        defaultValue={backgroundColor}
                                        placeholder='#FF00FF'
                                        onChange={this.handleColorChange.bind(this)}
                                    />
                                    {!colorValid && validateForm &&
                                        <FormText color='danger'>Color is required</FormText>
                                    }
                                    <Row><Col sm={12}><FormText>Color is used in-app for banner UI</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='startDate'>Program Start Date</Label>
                                <Col sm={8}>
                                    <DateInput id='startDate'
                                               className='form-control'
                                               minDate={moment().startOf("day")}
                                               selected={startDate}
                                               onChange={(d) => this.setState({startDate: d})}
                                    />
                                    <FormFeedback>Incorrect Date</FormFeedback>
                                    <Row><Col sm={12}><FormText>When should program experiences be available to users in app?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='endDate'>Program End Date</Label>
                                <Col sm={8}>
                                    <DateInput id='endDate'
                                               className='form-control'
                                               disabled={!startDate}
                                               minDate={startDate || moment().startOf("day")}
                                               selected={endDate}
                                               onChange={(d) => {
                                                   this.setState({endDate: d});
                                                   // if (scanText.lastIndexOf('This program has ended. Accumulated points will be transferred to your Dabbl balance on or after', 0) === 0) {
                                                   //     console.log('This program has ended. Accumulated points will be transferred to your Dabbl balance on or after ' + d.format('MM/DD/YYYY'))
                                                   //     console.log(this.scanTextRef.current)
                                                   //     this.scanTextRef.current.value = 'This program has ended. Accumulated points will be transferred to your Dabbl balance on or after ' + d.format('MM/DD/YYYY')
                                                   //     // this.setState({scanText: ('This program has ended. Accumulated points will be transferred to your Dabbl balance on or after ' + d.format('MM/DD/YYYY'))})
                                                   // }
                                               } }
                                    />
                                    {startDate >= endDate && validateForm &&
                                        <FormText color='danger'>End date shouid be greater than start date</FormText>
                                    }
                                    <Row><Col sm={12}><FormText sm={12}>Last date that users may view and complete active program experiences in app</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='displayDays'>Display Days</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="displayDays"
                                           id="displayDays"
                                           defaultValue={displayDays}
                                           onChange={(e) => this.setState({displayDays: e.target.value})}
                                           invalid={!(this.state.displayDays > 0) && validateForm}
                                           placeholder="display days"/>
                                    {!(this.state.displayDays > 0) && validateForm &&
                                        <FormText color='danger'>Invalid value for rolling days</FormText>
                                    }
                                    <Row><Col sm={12}><FormText>Number of days the program is visible to the user after completion.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="feedText" sm={4}>Earning Copy</Label>
                                <Col sm={8}>
                                    <Input name="feedText"
                                           id="feedText"
                                           defaultValue={feedText}
                                           onChange={(e) => this.setState({ feedText: e.target.value})}
                                           invalid={(!feedText || feedText.length === 0) && validateForm}
                                           placeholder={`Exclusive Earnings toward a ${cardAmount || ''} ${giftCard ? giftCard.title : ''} gift card`}/>
                                    <FormFeedback>Earning Copy is required</FormFeedback>
                                    <FormText>This is what the user will see when active Experiences are available</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="cardText" sm={4}>Ordering Copy</Label>
                                <Col sm={8}>
                                    <Input name="cardText"
                                           id="cardText"
                                           defaultValue={cardText}
                                           onChange={(e) => this.setState({ cardText: e.target.value})}
                                           invalid={(!cardText || cardText.length === 0) && validateForm}
                                           placeholder='You have a gift card waiting for you'/>
                                    <FormFeedback>Ordering Copy is required</FormFeedback>
                                    <FormText>This is what the user will see when they've reached the desired amount but before they order the gift card</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="endedText" sm={4}>Transferring Copy</Label>
                                <Col sm={8}>
                                    <Input name="endedText"
                                           id="endedText"
                                           defaultValue={endedText}
                                           ref={this.endedTextRef}
                                           onChange={(e) => this.setState({ endedText: e.target.value})}
                                           invalid={(!endedText || endedText.length === 0) && validateForm}
                                           placeholder={`Enter copy here...`}/>
                                    <FormFeedback>Transferring Copy is required</FormFeedback>
                                    <FormText>Tell the user what happens with partially earned points if they do not reach the gift card amount</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="scanText" sm={4}>Program End Copy</Label>
                                <Col sm={8}>
                                    <CustomInput type="checkbox" id="scanCtaCheckbox"
                                                 label="Add Receipt Scan CTA" inline
                                                 checked={scanCTA}
                                                 onChange={(e) => this.setState({ scanCTA: e.target.checked})}/>
                                    <Input name="scanText"
                                           id="scanText"
                                           defaultValue={scanText}
                                           onChange={(e) => this.setState({ scanText: e.target.value})}
                                           invalid={(!scanText || scanText.length === 0) && validateForm}
                                           // disabled={!scanCTA}
                                           placeholder=''/>
                                    <FormFeedback>Program End Copy is required</FormFeedback>
                                    <FormText>Alert user that the program has ended. If receipt scan CTA is checked, a receipt scan call-out is encouraged.</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="budget" sm={4}>Program Budget</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="budget"
                                           id="budget"
                                           defaultValue={budget}
                                           invalid={(!budget || Number(budget) < Number(cardAmount)) && validateForm}
                                           onChange={(e) => this.handleBudgetChange(e.target.value)}/>
                                    <FormFeedback>{!budget ? "Program Budget is required" : "Budget should be not less than gift card denomination"}</FormFeedback>
                                    <FormText>Enter total program budget for all experiences included in program</FormText>
                                </Col>
                            </FormGroup>
                            <br/>
                            {error &&
                                <div>
                                    { Object.entries(error).map(([key, value]) => <FormText color='danger' key={value}>{value}</FormText>)}
                                    <br/>
                                </div>
                            }
                            <div>
                                <Button isSubmit disabled={isUpdating}>{this.getSubmitText()}</Button>
                                { status === 'draft' &&
                                    <Button className='ml-2' disabled={isUpdating || isActivating || !this.isValidProgram()}
                                            onClick={() => this.onActivateClick()}>{this.state.isActivating ? 'Activating...' : 'Activate'}</Button>
                                }
                                <Button
                                    linkHref={this.getBackLink()}
                                    className='float-right'
                                    textColor='#666666'
                                    borderColor='#cccccc'
                                    backgroundColor='#ededed'> Cancel </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default EditProgram;



// WEBPACK FOOTER //
// ./src/routes/EditProgram/components/EditProgram.js